import {
  Component,
  Input,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
  ChangeDetectionStrategy,
  OnInit
} from '@angular/core';
import { SkyLinkRecordsMatchModel } from './state/matches/match.model';
import { SkyLinkRecordsApi } from './link-records-api';


export class SkyLinkRecordsRendererComponent implements OnInit {
   public item: any;
   public match: SkyLinkRecordsMatchModel;
   public fields: Array<any>;
   public template: TemplateRef<any>;
   public container: ViewContainerRef;

  constructor(public api: SkyLinkRecordsApi) {}

  public ngOnInit() {
    /* istanbul ignore else */
    if (this.template !== undefined) {
      this.container.createEmbeddedView(this.template, this);
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-link-records-renderer',
  template: '<ng-template #container></ng-template>',
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: SkyLinkRecordsApi, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'item': [{ type: Input },],
'match': [{ type: Input },],
'fields': [{ type: Input },],
'template': [{ type: Input },],
'container': [{ type: ViewChild, args: ['container', { read: ViewContainerRef }, ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
